export default {
  created () {
    this.uuid = Math.random().toString(36).substring(3, 8)
  }
}



// WEBPACK FOOTER //
// ./~/.0.1.3@vux/src/libs/mixin_uuid.js